import { FEATURE } from "../../../consts/Common";
import { GALLERY_SCHEMA } from "../../../consts/Template";
import Configs from "../../../Configurations";

const blob_url = Configs?.REACT_APP_IMAGE_STORAGE_URL || "https://blob.sparknotifications.walmart.com";

const Letter = {
  [GALLERY_SCHEMA.ID]: "comms_letter",
  [GALLERY_SCHEMA.NAME]: "Letter",
  [GALLERY_SCHEMA.CATEGORY]: FEATURE.COMMS_TEMPLATES,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#ffffff">
    <!-- Header Section - Walmart Wordmark -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="0px"
      padding-right="0px"
      background-color="#0053e2">
      <mj-column>
        <mj-image
          padding-top="32px"
          padding-bottom="32px"
          padding-left="0px"
          padding-right="0px"
          width="180px"
          align="center"
          src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-White-RGB.png"
          alt="Walmart">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Content Section -->
    <mj-section
      padding-top="24px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32">
          <p><strong>To:</strong> Lorem Ipsum</p>
          <p><strong>From:</strong> Lorem Ipsum</p>
          <p><strong>Date:</strong> January 2, 2024</p>
          <p><strong>Re:</strong> <strong>Subject line goes here</strong></p>
        </mj-text>
        <mj-divider
          border-width="1px"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          border-color="#e3e4e5">
        </mj-divider>
        <mj-text
          padding-top="16px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32">
          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32">
          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32">
          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
          <ul>
            <li>dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</li>
            <li>Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</li>
            <li>Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</li>
          </ul>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32">
          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="1.5"
          color="#2E2F32"
          align="center">
          <p style="text-align:center"><strong>. . .</strong></p>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Footer Section -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="0px"
      padding-right="0px"
      background-color="#0053e2">
      <mj-column>
        <mj-text
          padding-top="32px"
          padding-bottom="32px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="14px"
          line-height="1.5"
          color="#ffffff"
          align="center">
          <p style="text-align:center">{{{CURRENT_YEAR}}} Walmart Inc. - Confidential - Internal use only</p>
          <p style="text-align:center">Sent with Spark Notifications</p>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    p { display: block; margin: 13px 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
  </style>
</head>
<body style="word-spacing:normal;background-color:#ffffff;">
  <div style="background-color:#ffffff;">
    <!-- Header Section -->
    <div style="background:#0053e2;background-color:#0053e2;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0053e2;background-color:#0053e2;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0;padding-top:32px;padding-bottom:32px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:180px;">
                                <img height="auto" src="${blob_url}/templateeditortestteam-image/WMT-Wordmark-Standard-White-RGB.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="180" alt="Walmart">
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Content Section -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:24px;padding-left:24px;padding-right:24px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;padding-bottom:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong>To:</strong> Lorem Ipsum</p>
                          <p><strong>From:</strong> Lorem Ipsum</p>
                          <p><strong>Date:</strong> January 2, 2024</p>
                          <p><strong>Re:</strong> <strong>Subject line goes here</strong></p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;padding-top:16px;padding-bottom:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;padding-bottom:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;padding-bottom:8px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
                          <ul>
                            <li>dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</li>
                            <li>Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</li>
                            <li>Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:0;padding-bottom:16px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:left;color:#2E2F32;">
                          <p><strong>Lorem ipsum</strong> dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0;padding-bottom:24px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:1.5;text-align:center;color:#2E2F32;">
                          <p style="text-align:center"><strong>. . .</strong></p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Footer Section -->
    <div style="background:#0053e2;background-color:#0053e2;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0053e2;background-color:#0053e2;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:0;padding-top:32px;padding-bottom:32px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:14px;line-height:1.5;text-align:center;color:#ffffff;">
                          <p style="text-align:center">{{{CURRENT_YEAR}}} Walmart Inc. - Confidential - Internal use only</p>
                          <p style="text-align:center">Sent with Spark Notifications</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>
</html>`,
};
export default Letter;
